import { sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

export function useEnrichmentQuestions(eventId, {filter, sortBy: orderBy} = {}) {
    const selector = useCallback(state => state.events[eventId]?.enrichments?.questions, [eventId]),
    allQuestions = useSelector(selector) ?? [];

    return useMemo(() => {
        let result = allQuestions;
        if (filter) result = result.filter(filter);
        if (orderBy) result = sortBy(result, orderBy);
        return result;
    }, [allQuestions, filter, orderBy]);
}
